/**
 * GeoIP switcher bridge (SpiceGems "GeoIP Country Redirect" app)
 *
 * The header (announcement bar) shows a single "English | USD $" trigger that
 * opens the app's Market Switcher modal. The language / currency toggles in the
 * mobile drawer open the same modal instead of the theme's native dropdowns.
 * The app's own floating button is hidden via wc-geoip-switcher.css.
 *
 * If the app hasn't rendered its switcher (app embed disabled, script blocked,
 * still loading), the theme's native dropdowns are used instead.
 */
(function() {
  'use strict';

  var TOGGLE_SELECTOR =
    '.announcement-localization--wrapper [data-disclosure-toggle],' +
    '.mobile-menu__locales [data-disclosure-toggle]';

  function getSnippet() {
    return (
      document.querySelector('sgcr-switcher[data-switcher="market"]') ||
      document.querySelector('sgcr-switcher')
    );
  }

  function getModal(snippet) {
    var id = snippet && snippet.getAttribute('data-id');
    if (id) {
      var modal = document.querySelector(
        '.spicegems_switcher_modal[data-sg-template-id="' + id + '"]'
      );
      if (modal) return modal;
    }
    return document.querySelector('.spicegems_market_switcher_modal');
  }

  function isShown(modal) {
    return modal.style.display === 'block';
  }

  // The mobile drawer is a popover="auto" element, so it lives in the browser's
  // top layer and no z-index can put the modal above it. Promote the modal to
  // a popover too, opened through an invoker button inside the opener's
  // popover: that makes it a nested popover, so it stacks above the drawer
  // and the drawer stays open underneath.
  function showInTopLayer(modal, opener) {
    if (!('popover' in HTMLElement.prototype)) return;
    if (!modal.id) modal.id = 'wc-geoip-switcher-modal';

    if (!modal.hasAttribute('popover')) {
      modal.setAttribute('popover', 'auto');

      // Esc / light dismiss closed the popover -> close the app modal too
      modal.addEventListener('toggle', function(e) {
        if (e.newState === 'closed' && isShown(modal)) {
          modal.style.display = 'none';
        }
      });

      // App closed its modal (× / submit) -> leave the top layer
      new MutationObserver(function() {
        if (!isShown(modal) && modal.matches(':popover-open')) {
          modal.hidePopover();
        }
      }).observe(modal, { attributes: true, attributeFilter: ['style'] });
    }

    if (modal.matches(':popover-open')) return;

    var parentPopover = opener && opener.closest('[popover]:popover-open');
    if (parentPopover) {
      var invoker = document.createElement('button');
      invoker.type = 'button';
      invoker.hidden = true;
      invoker.setAttribute('popovertarget', modal.id);
      invoker.setAttribute('popovertargetaction', 'show');
      parentPopover.appendChild(invoker);
      invoker.click();
      invoker.remove();
    }

    if (!modal.matches(':popover-open')) {
      modal.showPopover();
    }
  }

  function openSwitcher(opener) {
    var snippet = getSnippet();
    var modal = getModal(snippet);
    if (!modal) return false;

    // The app opens its modal from a click listener on the <sgcr-switcher>
    // element; re-use it so its own logic (active-item scroll etc.) runs.
    if (snippet && snippet.childElementCount) {
      snippet.click();
    }
    if (!isShown(modal)) {
      modal.style.display = 'block';
    }

    try {
      showInTopLayer(modal, opener);
    } catch (err) {
      // Modal is still shown in the normal stacking context
    }
    return true;
  }

  // Capture phase so we run before the theme's Disclosure toggle handler.
  document.addEventListener(
    'click',
    function(e) {
      // Header "English | USD $" trigger. Without the app, reveal the
      // theme's native language/currency dropdowns instead.
      var trigger = e.target.closest('[data-wc-geoip-trigger]');
      if (trigger) {
        e.preventDefault();
        if (openSwitcher(trigger)) return;

        var wrapper = trigger.closest('.has-geoip-trigger');
        if (wrapper) {
          wrapper.classList.remove('has-geoip-trigger');
          var nativeToggle = wrapper.querySelector('[data-disclosure-toggle]');
          if (nativeToggle) nativeToggle.focus();
        }
        return;
      }

      var toggle = e.target.closest(TOGGLE_SELECTOR);
      if (!toggle) return;
      if (!openSwitcher(toggle)) return;

      e.preventDefault();
      e.stopPropagation();
    },
    true
  );

  window.WCGeoIPSwitcher = { open: openSwitcher };
})();
